module.exports = __webpack_public_path__ + "img/lotto.9caeaeaa.svg";